function infiniteScroll () {
  const current_url = window.location.pathname;
  if (current_url.includes("collections") || current_url.includes("search")) {
    const mainGrid = document.querySelector('#product-grid');
    const infiniteScrollElement = document.querySelector('.infinite__scroll--button-wrap')
    const Ajaxbutton = infiniteScrollElement.querySelector("#ajaxcall");
    let isLoading = false;
    if (Ajaxbutton && mainGrid) {
      let nextPageURL = Ajaxbutton.getAttribute('href');
      let Loading_More = infiniteScrollElement.querySelector('#loadmore');  
      
      const loadMoreContent = () => {
        if (isLoading || !nextPageURL) return; 
      
        isLoading = true; 
      
        fetch(nextPageURL)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            let parsedHTML = new DOMParser().parseFromString(text, 'text/html');
            let productGrid = parsedHTML.querySelector('#product-grid');
            let nextUrl = parsedHTML.querySelector('#ajaxcall');
      
            if (!nextUrl) {
              Loading_More.innerText = "No More Products";
              nextPageURL = null;
            } else {
              nextPageURL = nextUrl.href;
            }      
            if (productGrid) {
              mainGrid.insertAdjacentHTML('beforeend', productGrid.innerHTML);
            }
            isLoading = false;
            // handleVariantAnchorClick();
            const allproducts = document.querySelectorAll('#product-grid .grid__item');
            if(allproducts.length > 0){
            allproducts.forEach(product=>{
              const allColors = product.querySelectorAll('.color__swatches-swatch');
              if(allColors.length > 0){
                  allColors.forEach(color=>{
                      color.addEventListener('click',(e)=>{
                          allColors.forEach(col=>{
                              col.classList.remove('active')
                          })
                          color.classList.add('active')
                          const productElement = color.closest('.grid__item');
                          productElement.setAttribute('data-images','')
                          productElement.querySelector('img').srcset = color.getAttribute('data-variantimg');
                      })
                  })
              }})}
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            isLoading = false;
          });
      };
    
      window.addEventListener('scroll', function () {
        const mainGridRect = mainGrid.getBoundingClientRect();
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const triggerOffset = mainGridRect.height / 2;
        // console.log(triggerOffset)
      
        if (scrollTop + windowHeight >= mainGridRect.top + triggerOffset) {
          loadMoreContent();
        }
      });
    }
  }
}

infiniteScroll();

// function autoLoader(){
//     const current_url = window.location.pathname;
//     if (current_url.includes("collections") || current_url.includes("search")) {
//       var products_on_page = document.getElementById("product-grid");
//       const loadmore_btn = document.querySelector(".load-more-cstm-btn");
//       let next_url = loadmore_btn.getAttribute("href");
    
//       function loadMoreProducts() {

//         document.querySelector('body').classList.add("loading"); 
//         setTimeout(()=>{
//           document.querySelector('body').classList.remove("loading");  
//         },1000)
//         fetch(next_url)
//           .then((response) => {
//             loadmore_btn.style.display = "none";
//             return response.text();
//           })
//           .then((data) => {
//             var parser = new DOMParser();
//             var doc = parser.parseFromString(data, "text/html");
//             var return_html = doc.body;
//             console.log(return_html.querySelector('#load-more-cstm-btn'))
//             var main_html = return_html.querySelector("#product-grid");
//             var main_html_child = main_html.querySelectorAll(".grid__item");
//             var new_url = main_html.getAttribute("data-next-url");
//             if (new_url) {
//               document.querySelector("#product-grid").setAttribute("data-next-url",main_html.getAttribute('data-next-url'))
//               loadmore_btn.style.display = "none";
//               document.documentElement.classList.remove("loading");
//             }
//             else{
//               document.documentElement.classList.remove("loading");
//             }
//             next_url = new_url;
//             let mainProductWrapper = document.querySelector(".product-grid");
//             setTimeout(() => {
//               main_html_child.forEach(function (value, index) {             
//                 document.querySelector(".product-grid").append(value);
//               });
//               const allproducts = document.querySelectorAll('#product-grid .grid__item');
//               if(allproducts.length > 0){
//               allproducts.forEach(product=>{
//                 const allColors = product.querySelectorAll('.color__swatches-swatch');
//                 if(allColors.length > 0){
//                     allColors.forEach(color=>{
//                         color.addEventListener('click',(e)=>{
//                             allColors.forEach(col=>{
//                                 col.classList.remove('active')
//                             })
//                             color.classList.add('active')
//                             const productElement = color.closest('.grid__item');
//                             productElement.setAttribute('data-images','')
//                             productElement.querySelector('img').srcset = color.getAttribute('data-variantimg');
//                         })
//                     })
//                 }})}
              


//                 // const productGrid = document.querySelectorAll('#product-grid')
//                 // const jsonData = JSON.parse(productGrid[0].getAttribute('data-blocks'))
//                 // const allProducts = document.querySelectorAll('li.grid__item')
//                 // const handle = productGrid[0].getAttribute('data-handle')
//                 // jsonData.forEach(settings=>{

//                 //   if(settings.featured_banner_links == handle && settings.banner_image ){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link}">
//                 //       <img src="${settings.banner_image}" alt="${settings.featured_banner_links}" loading="lazy" >
//                 //       </a>
//                 //       `
//                 //       if(allProducts[settings.show_after - 1] && !allProducts[settings.show_after - 1].classList.contains('checked')){
//                 //       console.log(settings.show_after)
//                 //       allProducts[settings.show_after - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after - 1].classList.add('checked')
//                 //     }
//                 //   }
            
//                 //   if(settings.featured_banner_links2 == handle && settings.banner_image2){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link2}">
//                 //     <img src="${settings.banner_image2}" alt="${settings.featured_banner_links2}" loading="lazy" >
//                 //     </a>
//                 //     `
//                 //     if(allProducts[settings.show_after2 - 1] && !allProducts[settings.show_after2 - 1].classList.contains('checked')){
//                 //       console.log(settings.show_after2)
//                 //       allProducts[settings.show_after2 - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after2 - 1].classList.add('checked')
//                 //     }
//                 //   }
//                 //   if(settings.featured_banner_links3 == handle && settings.banner_image3){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link3}">
//                 //       <img src="${settings.banner_image3}" alt="${settings.featured_banner_links3}" loading="lazy" >
//                 //      </a>
//                 //      `
//                 //      if(allProducts[settings.show_after3 - 1] &&  !allProducts[settings.show_after3 - 1].classList.contains('checked')){
//                 //        console.log(settings.show_after3)
//                 //       allProducts[settings.show_after3 - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after3 - 1].classList.add('checked')
//                 //     }
//                 //   }
//                 //   if(settings.featured_banner_links4 == handle && settings.banner_image4){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link4}">
//                 //       <img src="${settings.banner_image4}" alt="${settings.featured_banner_links4}" loading="lazy" >
//                 //       </a>
//                 //       `
//                 //       if(allProducts[settings.show_after4 - 1] && !allProducts[settings.show_after4 - 1].classList.contains('checked')){
//                 //        console.log(settings.show_after4)
//                 //       allProducts[settings.show_after4 - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after4 - 1].classList.add('checked')
//                 //     }
//                 //   }
//                 //   if(settings.featured_banner_links5 == handle && settings.banner_image5){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link5}">
//                 //       <img src="${settings.banner_image5}" alt="${settings.featured_banner_links5}" loading="lazy" >
//                 //       </a>
//                 //       `
//                 //       if(allProducts[settings.show_after5 - 1] && !allProducts[settings.show_after5 - 1].classList.contains('checked')){
//                 //        console.log(settings.show_after5)
//                 //       allProducts[settings.show_after5 - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after5 - 1].classList.add('checked')
//                 //     }
//                 //   }
//                 //   if(settings.featured_banner_links6 == handle && settings.banner_image6 ){
//                 //     const banner = document.createElement('li');
//                 //     banner.classList.add('grid__item')
//                 //     banner.classList.add('grid__item-img')
//                 //     banner.innerHTML = `
//                 //     <a href="${settings.banner_link6}">
//                 //       <img src="${settings.banner_image6}" alt="${settings.featured_banner_links6}" loading="lazy" >
//                 //      </a>
//                 //      `
//                 //      if(allProducts[settings.show_after6 - 1] && !allProducts[settings.show_after6 - 1].classList.contains('checked')){
//                 //        console.log(settings.show_after6)
//                 //       allProducts[settings.show_after6 - 1].insertAdjacentElement('afterend',banner);
//                 //       allProducts[settings.show_after6 - 1].classList.add('checked')
//                 //     }
//                 //     }})






//               if (new_url) {
//                 loadmore_btn.style.display = "block";
//                 document.querySelector('body').classList.remove("loading");  
  
//               } else {
//                 document.querySelector('body').classList.remove("loading");
//                 loadmore_btn.style.display = "block";
//                 loadmore_btn.classList.add("ds-no-more-products-left");
//                 loadmore_btn.classList.add("ds-no-more-products-left");
//                 loadmore_btn.textContent="No more products";
//               }
//             }, 600);
//           })
//           .catch((err) => {
//             console.log(err);
//           });
//       }
    
//       if (document.querySelectorAll("#load-more-cstm-btn").length > 0) {
//         if (
//           document
//             .querySelector("#load-more-cstm-btn")
//             .classList.contains("ds-no-more-products-left")
//         ) {
//         } else {
//           document
//             .querySelector("#load-more-cstm-btn")
//             .addEventListener("click", () => {
//               setTimeout(loadMoreProducts,500)
//             });
//         }
//       }
//       var btnClick = new Event("click");
//       document.addEventListener("scroll", function () {
//         var collectionTplElm = document.querySelector(".collection_top-wrapper");
//         var collectionTop = window.innerHeight;
//         var collectionHeight = collectionTplElm.clientHeight;
//         var posTop = collectionTop + collectionHeight - window.innerHeight;
        
//         if (window.scrollY > posTop - 10000 && window.scrollY < ( posTop + 5000  ))  {
//           if (loadmore_btn) {
//             if (loadmore_btn.classList.contains("btn-disabled")) {
//             } else {
//               loadmore_btn.dispatchEvent(btnClick);
//               loadmore_btn.classList.add("btn-disabled");
//               setTimeout(function () {
//                 if (loadmore_btn) {
//                   if (loadmore_btn.classList.contains("ds-no-more-products-left")) {
//                   } else {
//                     loadmore_btn.classList.remove("btn-disabled");
//                   }
//                 }
//               }, 3000);
//             }
//           }
//         }
//       });
//     }
   
//     }
// autoLoader();
  


    const allproducts = document.querySelectorAll('#product-grid .grid__item');
    if(allproducts.length > 0){
    allproducts.forEach(product=>{
      const allColors = product.querySelectorAll('.color__swatches-swatch');
      if(allColors.length > 0){
          allColors.forEach(color=>{
              color.addEventListener('click',(e)=>{
                  allColors.forEach(col=>{
                      col.classList.remove('active')
                  })
                  color.classList.add('active')
                  const productElement = color.closest('.grid__item');
                  productElement.setAttribute('data-images','')
                  productElement.querySelector('img').srcset = color.getAttribute('data-variantimg');
              })
          })
      }})}
      const sortButton = document.querySelector('h2.facet-filters__label');
      sortButton.addEventListener('click',(e)=>{
          e.preventDefault();
          const sortElement =  document.querySelector('.sort__options');
          sortElement.classList.toggle('hidden')
          const sortElementOverlay =  document.querySelector('.overlay-wrap');
          sortElementOverlay.classList.toggle('hidden')
      })
      const sortElementOverlay =  document.querySelector('.overlay-wrap');
      sortElementOverlay.addEventListener('click',(e)=>{
          e.preventDefault();
          const sortElement =  document.querySelector('.sort__options');
          sortElement.classList.add('hidden')
          const sortElementOverlay =  document.querySelector('.overlay-wrap');
          sortElementOverlay.classList.add('hidden')
      })
      const menuCloseButton =  document.querySelector('.close__menu');
      menuCloseButton.addEventListener('click',()=>{document.querySelector('body').classList.remove('overflow--hidden')})